import React from 'react';
import { cx } from '@/ui/utils/cx';

export type AppSelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  inputSize?: 'sm' | 'md' | 'lg';
  hasError?: boolean;
};

const AppSelect = React.forwardRef<HTMLSelectElement, AppSelectProps>(function AppSelect(
  { className, inputSize = 'md', hasError = false, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cx(
        'app-control',
        inputSize !== 'md' && `app-control--${inputSize}`,
        hasError && 'app-control--error',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});

export default AppSelect;
